
/**
 * SEO 配置 - models (Español)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Generador de video IA insignia | WeryAI',
        description: 'Google Veo 3.1: Modelo de video AI insignia con audio nativo y control de fotogramas.',
        keywords: 'Google Veo 3.1, video IA insignia, generador de video IA, WeryAI',
    },
    veo_3: {
        title: 'veo 3 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast Generación de Video e Imagen IA | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 Generación de Video IA | WeryAI',
        description: 'WeryAI Video 1.0 para crear videos IA cinemáticos.',
        keywords: 'WeryAI Video 1.0, video IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Generador de Imágenes IA Nativo | WeryAI',
        description: '¡Usa WeryAI Image 2 para generación nativa de imágenes IA impresionantes! Modelo insignia con control de estilo avanzado. Créditos gratis, sin tarjeta.',
        keywords: 'WeryAI Image 2, generador de imágenes IA nativo, imagen IA insignia, calidad estudio IA, WeryAI Image gratis, cómo usar WeryAI Image 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Generador de Imágenes | WeryAI',
        description: 'Nano Banana 2 impulsado por Gemini con conocimiento mundial y búsqueda en tiempo real. Genera imágenes factualmente precisas y hermosas a velocidad ultrarrápida.',
        keywords: 'Nano Banana 2, Google AI, Gemini, generación de imágenes, renderizado de texto, consistencia multi-sujeto, 4K, WeryAI',
        og_title: 'Generador de imágenes Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 está impulsado por Gemini con comprensión profunda del mundo y búsqueda en tiempo real, generando imágenes hermosas y factualmente precisas.',
        twitter_title: 'Generador de imágenes Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 está impulsado por Gemini con comprensión profunda del mundo y búsqueda en tiempo real, generando imágenes hermosas y factualmente precisas.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Generador de imágenes AI Nano Banana 2',
        twitterImageAlt: 'Generador de imágenes AI Nano Banana 2',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - Generador de Imágenes xAI | WeryAI',
        description: '¡Usa Grok 2 en WeryAI para generar imágenes IA creativas! Modelo xAI con flexibilidad artística y estilos visuales únicos. Créditos gratis, sin tarjeta.',
        keywords: 'Grok 2, Grok AI, generador de imágenes xAI, arte IA, imágenes IA creativas, Grok 2 gratis, cómo usar Grok 2, WeryAI',
    },
    kling_ai: {
        title: 'kling ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai Generación de Video e Imagen IA | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 Generación de Video e Imagen IA | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance Generación de Video e Imagen IA | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Generador de Video AI de Director | WeryAI',

        description: 'Crea videos AI de nivel director con Werydance 2.0: referencias multimodales, consistencia narrativa y simulación física. Gratis en WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, generador de video AI, video nivel director, video multimodal, simulación física, sincronización labial, texto a video, video AI gratis, WeryAI',

        og_title: 'Werydance 2.0 - Generador de Video AI de Director | WeryAI',

        og_description: 'Crea videos AI de nivel director con Werydance 2.0: referencias multimodales, consistencia narrativa y simulación física. Gratis en WeryAI.',

        twitter_title: 'Werydance 2.0 - Generador de Video AI de Director | WeryAI',

        twitter_description: 'Crea videos AI de nivel director con Werydance 2.0: referencias multimodales, consistencia narrativa y simulación física. Gratis en WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_2_6: {
        title: 'Wan 2.6 Generador de video con IA avanzado | WeryAI',
        description: 'Wan 2.6 es el nuevo modelo multimodal insignia de Alibaba para generación de video con IA, con calidad cinematográfica 1080p, sincronización nativa de audio y video y capacidades inteligentes de narrativa multi-toma. Pruébalo gratis en WeryAI.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, generador de video con IA, modelo de video multimodal, texto a video, imagen a video, sincronización de audio, WeryAI Wan 2.6',
    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - Generador de Imágenes OpenAI | WeryAI',
        description: '¡Usa GPT-4o en WeryAI para crear imágenes por conversación! IA de OpenAI con renderizado de texto preciso y resultados de alta fidelidad. Créditos gratis, sin tarjeta.',
        keywords: 'GPT-4o, GPT-4o imagen, generador de imágenes OpenAI, arte IA conversacional, GPT-4o gratis, cómo usar GPT-4o imágenes, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - Generador de Imágenes IA | WeryAI',
        description: '¡Usa Nano Banana Pro en WeryAI para las imágenes IA de mayor fidelidad! Rivaliza con Midjourney en calidad. Créditos gratis, sin tarjeta.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google imagen IA, imagen IA por razonamiento, 4K imagen IA, Nano Banana Pro gratis, cómo usar Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - Generador de Imágenes IA | WeryAI',
        description: '¡Usa Nano Banana en WeryAI para crear imágenes IA fácilmente! Modelo IA rápido y versátil para todas tus necesidades creativas. Créditos gratis, sin tarjeta.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google imagen IA, generador IA rápido, consistencia de personajes, Nano Banana gratis, cómo usar Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Prueba el Generador de Imágenes IA | WeryAI',
        description: '¡Usa FLUX en WeryAI para generar imágenes IA increíbles! Creado por el equipo de Stable Diffusion con calidad visual excepcional. Créditos gratis, sin tarjeta.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, generador de imágenes IA, texto a imagen, arte IA, FLUX gratis, cómo usar FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Editor de Imágenes IA Pro | WeryAI',
        description: '¡Usa FLUX Kontext en WeryAI para edición profesional de imágenes IA! Precisión superior, tipografía avanzada y edición multi-paso. Créditos gratis, sin tarjeta.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, editor de imágenes IA, imágenes IA pro, tipografía IA, FLUX Kontext gratis, cómo usar FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Generador de Imágenes IA Google | WeryAI',
        description: '¡Usa Google Imagen 4 en WeryAI para crear imágenes IA fotorrealistas! Control de estilos versátil y generación de texto precisa. Créditos gratis, sin tarjeta.',
        keywords: 'Imagen 4, Google Imagen, generador de imágenes IA Google, texto a imagen, IA fotorrealista, Imagen gratis, cómo usar Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Modelo de Imágenes IA Alibaba | WeryAI',
        description: '¡Usa Qwen Image en WeryAI para generar arte IA multilingüe! Modelo de código abierto de Alibaba con renderizado de texto superior. Créditos gratis, sin tarjeta.',
        keywords: 'Qwen Image, Alibaba AI, imagen IA código abierto, renderizado de texto multilingüe, Qwen Image gratis, cómo usar Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Generador de Imágenes Alibaba | WeryAI',
        description: '¡Usa Wan AI en WeryAI para imágenes IA de alta fidelidad! Modelo Alibaba con seguimiento preciso de prompts y renderizado fotorrealista. Créditos gratis, sin tarjeta.',
        keywords: 'Wan AI, Wan 2.5, generador de imágenes IA Alibaba, texto a imagen, IA fotorrealista, Wan AI gratis, cómo usar Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Imagen IA | WeryAI',
        description: '¡Usa Seedream 4.0 en WeryAI para generación ultrarrápida de imágenes IA! Modelo ByteDance con estilos artísticos diversos. Créditos gratis, sin tarjeta.',
        keywords: 'Seedream, Seedream 4.0, ByteDance imagen IA, imagen IA ultrarrápida, estilos artísticos IA, Seedream gratis, cómo usar Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - IA de Imagen Multimodal | WeryAI',
        description: '¡Usa Dreamina 4.0 en WeryAI para creación de imágenes IA multimodal! Boceto a imagen, transferencia de estilo y fusión de personajes. Créditos gratis, sin tarjeta.',
        keywords: 'Dreamina 4.0, ByteDance imagen IA, imagen IA multimodal, boceto a imagen, transferencia de estilo, Dreamina gratis, cómo usar Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Imagen IA | WeryAI',
        description: '¡Usa Seedream 4.5 en WeryAI para generación de imágenes IA insignia! Lo último de ByteDance con tipografía precisa y fusión multi-imagen. Créditos gratis, sin tarjeta.',
        keywords: 'Seedream 4.5, ByteDance imagen IA, modelo insignia, renderizado tipográfico, fusión multi-imagen, Seedream 4.5 gratis, cómo usar Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Modelo Definitivo de Generación | WeryAI',
        description: 'Seedream 5.0 es la obra maestra de ByteDance en IA visual con calidad nativa 8K, comprensión semántica definitiva, composición multi-sujeto y renderizado de texto 2.0. Pruébalo gratis en WeryAI.',
        keywords: 'Seedream 5.0, generación de imágenes IA, calidad 8K, comprensión semántica, composición multi-sujeto, renderizado de texto, ByteDance, WeryAI',
        og_title: 'Generador de Imágenes Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 es la obra maestra de ByteDance en generación visual con IA, con calidad nativa 8K, comprensión semántica definitiva, composición multi-sujeto y renderizado de texto avanzado.',
        twitter_title: 'Generador de Imágenes Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 es la obra maestra de ByteDance en generación visual con IA, con calidad nativa 8K, comprensión semántica definitiva, composición multi-sujeto y renderizado de texto avanzado.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Generador de imágenes AI Seedream 5.0',
        twitterImageAlt: 'Generador de imágenes AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Generador Profesional de Gráficos Vectoriales IA | WeryAI',
        description: 'Recraft V4 Vector es un generador profesional de gráficos vectoriales IA de Recraft.ai que genera vectores SVG editables con escalado sin pérdidas, tipografía precisa y control de estilo de marca. Pruébalo gratis en WeryAI ahora.',
        keywords: 'Recraft V4 Vector, generación de vectores IA, generador SVG, vector verdadero, diseño de logotipos, iconos UI, ilustración vectorial, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Generador de Arte IA | WeryAI',
        description: '¡Usa Midjourney en WeryAI para crear imágenes IA artísticas! Famoso por su estética impresionante y calidad de iluminación. Créditos gratis, sin tarjeta.',
        keywords: 'Midjourney, Midjourney AI, generador de arte IA, imágenes IA artísticas, Midjourney gratis, alternativa a Midjourney, cómo usar Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generador de Video IA | WeryAI',
        description: 'Crea videos impresionantes con Runway Gen-4.5 en WeryAI. Arquitectura híbrida autorregresiva-difusión para simulación física precisa y consistencia temporal.',
        keywords: 'Runway Gen-4.5, generador de video IA, video IA cinematográfico, simulación física, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generador de Video IA | WeryAI',
        description: 'Genera videos de alta calidad con Kling 2.6 Pro en WeryAI. Generación audiovisual nativa, calidad cinematográfica 1080p, excelente adherencia a prompts.',
        keywords: 'Kling 2.6 Pro, generador de video IA, video IA de alta calidad, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generador de Video | WeryAI',
        description: 'Genera videos IA cinematográficos con Dreamina 3.0 (Jimeng 3.0) en WeryAI. Control preciso de fotogramas inicio/fin, movimientos de cámara profesionales y generación de video 1080p de alto dinamismo.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generador de video IA, control de cámara, fotogramas inicio fin, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generador de Video IA | WeryAI',
        description: 'Libera tu creatividad en WeryAI con el generador de video IA Kling O1. Perfecto para generar contenido de video imaginativo y único.',
        keywords: 'Kling O1, generador de video IA, video IA creativo, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Generador de Video AI Inteligente | WeryAI',

        description: 'Crea videos AI con Kling 3.0: storyboard inteligente, sincronización labial multilingüe y renderizado de texto preciso. Prueba gratis en WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, generador de video AI, storyboard inteligente, sincronización labial, renderizado de texto, texto a video, imagen a video, video AI gratis, WeryAI',

        og_title: 'Kling 3.0 - Generador de Video AI Inteligente | WeryAI',

        og_description: 'Crea videos AI con Kling 3.0: storyboard inteligente, sincronización labial multilingüe y renderizado de texto preciso. Prueba gratis en WeryAI.',

        twitter_title: 'Kling 3.0 - Generador de Video AI Inteligente | WeryAI',

        twitter_description: 'Crea videos AI con Kling 3.0: storyboard inteligente, sincronización labial multilingüe y renderizado de texto preciso. Prueba gratis en WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Generador Audio-Video AI Nativo 16s | WeryAI',

        description: 'Genera audio-video nativo de 16 segundos con Vidu Q3: cortes inteligentes, renderizado de texto preciso y lip-sync multilingüe. Gratis en WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, generador de video AI, audio-video nativo 16s, storyboard inteligente, renderizado de texto, sincronización labial, texto a video, imagen a video, video AI gratis, WeryAI',

        og_title: 'Vidu Q3 - Generador Audio-Video AI Nativo 16s | WeryAI',

        og_description: 'Genera audio-video nativo de 16 segundos con Vidu Q3: cortes inteligentes, renderizado de texto preciso y lip-sync multilingüe. Gratis en WeryAI.',

        twitter_title: 'Vidu Q3 - Generador Audio-Video AI Nativo 16s | WeryAI',

        twitter_description: 'Genera audio-video nativo de 16 segundos con Vidu Q3: cortes inteligentes, renderizado de texto preciso y lip-sync multilingüe. Gratis en WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - Generador de Arte OpenAI | WeryAI',
        description: '¡Usa GPT Image 1.5 en WeryAI para arte IA de nueva generación! Último modelo de OpenAI con creatividad y detalle mejorados. Créditos gratis, sin tarjeta.',
        keywords: 'GPT Image 1.5, modelo de imagen OpenAI, generador de arte IA, IA de nueva generación, GPT Image 1.5 gratis, cómo usar GPT Image 1.5, WeryAI',
    },
}
